import { BOTICARIO_CYCLES_LENGTH } from 'core/domains/utilities';
import { CycleDetail } from 'core/services/bff/@types';

export function checkIfCanChooseCycle(cycles: CycleDetail[]) {
  const filterCycleByBoticario = cycles.filter((cycle) => cycle.brand === 'BOTICARIO');
  return filterCycleByBoticario.length === BOTICARIO_CYCLES_LENGTH.HAS_EXTENDED_CAPTATION;
}
